"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgCustomScan = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 44, height: 44, strokeWidth: 2.75, strokeLinecap: "square" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", stroke: "currentColor", d: "M35.99 16.5c-1.994-6.363-8.174-11-15.488-11-8.927 0-16.164 6.909-16.164 15.431 0 8.523 7.237 15.432 16.164 15.432 1.47 0 2.894-.187 4.248-.539M9.26 32.466 2.921 38.5" }), (0, jsx_runtime_1.jsx)("path", { fill: "none", stroke: "currentColor", d: "M40.017 28.649c0 2.738-1.578 4.351-4.257 4.351h-7.662c-2.686 0-4.265-1.613-4.265-4.351v-5.965c0-2.737.984-4.35 3.663-4.35h1.497c.538 0 1.044.258 1.367.698l.683.929c.323.439.83.697 1.367.698h3.951c2.686 0 3.677 1.397 3.677 4.19l-.02 3.8z" })] }))); };
exports.default = SvgCustomScan;
